import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { Vervolgstap } from '@common/customControls/bariatrics';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';

export const bariPreCaroInactivityPoliReportVervolgstappen = [
    Vervolgstap.activatielink_opnieuw_versturen,
    Vervolgstap.geen_actie_nodig,
] as const;

type bariPreCaroInactivityPoliReportVervolgstap = (typeof bariPreCaroInactivityPoliReportVervolgstappen)[number];

export type BariPreCaroInactivityPoliReportData = {
    verslag: string | null;
    vervolgstap: bariPreCaroInactivityPoliReportVervolgstap | null;
};

const bariPreCaroInactivityPoliReportFinal: TypedSchema<BariPreCaroInactivityPoliReportData> = {
    verslag: getTextAreaStringSchema(),
    vervolgstap: Koi.koi().valid(...bariPreCaroInactivityPoliReportVervolgstappen),
};

const bariPreCaroInactivityPoliReportDraft = addAllowNull(bariPreCaroInactivityPoliReportFinal);

export const bariPreCaroInactivityPoliReportDraftSchema = Koi.object(bariPreCaroInactivityPoliReportDraft);
export const bariPreCaroInactivityPoliReportFinalSchema = Koi.object(bariPreCaroInactivityPoliReportFinal);

export type bariPreCaroInactivityPoliReportReadKey = keyof BariPreCaroInactivityPoliReportData | 'inactiviteit';
export type bariPreCaroInactivityPoliReportReadLabel = 'Inactiviteit' | 'Verslag' | 'Vervolgstap';

export const bariPreCaroInactivityPoliReportReadSchema: TypedReadSchema<
    bariPreCaroInactivityPoliReportReadKey,
    bariPreCaroInactivityPoliReportReadLabel
>[] = [
    {
        items: [
            {
                key: 'inactiviteit',
                label: 'Inactiviteit',
            },
            {
                key: 'verslag',
                label: 'Verslag',
            },
            {
                key: 'vervolgstap',
                label: 'Vervolgstap',
            },
        ],
    },
];
